'use strict'

window.OrderWorklistSharedFunctions = {
    checkAndSetUrgencyFilterActive: () => {
        const urgencyFilterDefault = true;

        OrderReportWorklistShared.checkAndSetMultiSelectFilterIsActive(".visibleUrgencies", ".checkUrgencyVis", urgencyFilterDefault);
    },
    checkAndSetPatientStatusFilterActive: () => {
        const patientStatusFilterDefault = false;

        OrderReportWorklistShared.checkAndSetMultiSelectFilterIsActive(".visiblePatientStatuses", ".checkPatientStatusVis", patientStatusFilterDefault);
    },
    checkAndSetPatientOriginFilterActive: () => {
        const patientOriginFilterDefault = false;

        OrderReportWorklistShared.checkAndSetMultiSelectFilterIsActive(".visiblePatientOrigin", ".checkPatientOriginVis", patientOriginFilterDefault);
    },
    checkAndSetInvoiceFilterActive: () => {
        const invoiceFilterDefault = false;

        OrderReportWorklistShared.checkAndSetMultiSelectFilterIsActive(".visibleInvoiceStatuses", ".checkInvoiceStatusVis", invoiceFilterDefault);
    },
    checkAndSetStatusFilterActive: () => {
        const statusFilterDefault = true;

        OrderReportWorklistShared.checkAndSetMultiSelectFilterIsActive(".visibleStatusInOrder", ".checkStatusVis", statusFilterDefault);
    },
    checkAndSetLabelFilterActive: () => {
        const labelFilterDefault = false;

        OrderReportWorklistShared.checkAndSetMultiSelectFilterIsActive(".visibleLabelInOrder", ".checkLabelVis", labelFilterDefault);
    }
}
